import { render } from "./GoalSubHeaderLayout.vue?vue&type=template&id=a8ebdaac&scoped=true"
import script from "./GoalSubHeaderLayout.vue?vue&type=script&lang=js"
export * from "./GoalSubHeaderLayout.vue?vue&type=script&lang=js"

import "./GoalSubHeaderLayout.vue?vue&type=style&index=0&id=a8ebdaac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a8ebdaac"

export default script